import KitchenHeader from './KitchenHeader';
import NotInformation from '../../../../components/NotInformation';
import React from 'react';
import OrderApp from '../Functionality/OrderApp';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import defaultImage from '../../../../assets/ImagesDefaults/ic-person.svg';
import CustomChip from '../../../../components/CustomChip';
import {colors} from '../../../../enums/colors';
import CustomCardGridGeneral from '../../../../components/CustomCardGridGeneral';
import CustomCard from '../../../../components/CustomCard';
import {
    IconKitchenTickets,
    IconTextMessage
} from '../../../../components/buttons/IconButtons';
import {permissionObj} from '../../../../Helpers/permission';
import ButtonIcon from '../../../../components/buttons/ButtonIcon';
import CustomTooltip from '../../../../components/CustomTooltip';
import { MEAL_CATEGORY } from '../../Dining/Manage/Models/Model';
import {EMPTY_VALUES, getFullName, getTimeFormat } from '../../../../Apis/functions';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model item: model of header section
 * @param event handleChange: Event to update the module in the header section
 * @param useState search: Variable for searching the items
 * @param useState setSearch: State to update the search variable for items
 * @param boolean isOnline: Variable that indicates whether the WebSocket is open
 * @param useState setIsOnline: Variable to update the WebSocket state when it opens or closes
 * @param boolean isReload: Variable to indicate that the WebSocket will be opened manually if the connection fails
 *  @param boolean activeStep: Variable to indicate which tab is active
 *
 */
const Order = ({item, handleChange, search, setSearch, isOnline, setIsOnline, modified, setModified, activeStep}) => {

    const { t, elementRef,
        DEV,
        permission,
        withSearchOrders,
        scheduleOrders,
        serverOrders,
        pendingOrders,
        handleMarkAsCompleted,
        searchId
    } = OrderApp({
        item,
        search,
        isOnline,
        setIsOnline,
        modified,
        setModified,
        activeStep
    });

    const Resume = ({title, value}) => {
        return (<div className={"col-12 p-0"}>
            <div className='d-flex gap-3'>
            <p className="ibl-description ibl-font-w-700 font-color-general-950 w-90px">{title}</p>

            <div className={"flex-grow-1 minw-0"}>
                <CustomTooltip
                    text={value}
                    classes={"ibl-ientry-p ibl-font-w-500 font-color-shades-600 text-ellipsis-1-row"}
                    showIfTruncated={true}
                    placement={"top"}
                />
            </div>
        </div></div>)
    }

    const ContentCard = ({title='', value='', classColorText=''  }) => {
        return (<div className='d-flex align-items-center gap-9px'>
            <div><IconKitchenTickets width={48} height={48}/></div>
            <div className='d-flex flex-column justify-content-end align-items-start gap-2px'>
                <p className={`p-0 m-0 ibl-ientry-p ibl-font-w-700 ${classColorText}`}>{t(title)}</p>
                <p className={`p-0 m-0 fs-24px ibl-font-w-700 ${classColorText}`}>{value}</p>
            </div>
        </div>)
    }

    const ContentCardHeader = ({schedule=0, server=0, pendingOrders=0}) => {
        return (<>
            <div className='col-3'>
                <CustomCard
                    classes='d-flex flex-column h-100'
                    classContent={'p-10px'}
                    classCard='card-secondary-400-200'
                >
                    <ContentCard title="schedule_orders" value={schedule} classColorText='font-color-secondary-600'/>
                </CustomCard>
            </div>
            <div className='col-3'>
                <CustomCard
                    classes='d-flex flex-column h-100'
                    classContent={'p-10px'}
                    classCard='card-success-400-200'
                >
                    <ContentCard title="server_orders" value={server} classColorText='font-color-success-600'/>
                </CustomCard>
            </div>
            <div className='col-3'>
                <CustomCard
                    classes='d-flex flex-column h-100'
                    classContent={'p-10px'}
                    classCard='card-warning-400-200'
                >
                    <ContentCard title="pending_orders" value={pendingOrders } classColorText='font-color-warning-600'/>
                </CustomCard>
            </div>
        </>)
    }

    return (<>
        <KitchenHeader
            item={item}
            handleChange={handleChange}
            search={search}
            setSearch={setSearch}
            activeStep={activeStep}
            searchId={searchId}
        />
        <div className='row my-4'>
           <ContentCardHeader schedule={scheduleOrders} server={serverOrders} pendingOrders={pendingOrders}/>
        </div>
        <>
            {withSearchOrders?.length > 0 ? (
                <div ref={elementRef}>
                    <div className='row'>
                        {withSearchOrders?.map((item, index) => (
                            <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 px-1 mb-3'>
                                <CustomCardGridGeneral
                                    previewImage={item?.selfie ? `data:image/png;base64,${item?.selfie}` : defaultImage}
                                    classNameWH='w-100px-h-100px'
                                    headImage={
                                        <div className="d-flex justify-content-end gap-1">
                                            <CustomChip
                                                background={colors.secondary100}
                                                borderColor={colors.secondary150}
                                                fontColor={colors.secondary700}
                                                legend={item?.mealTimeName || EMPTY_VALUES.DEFAULT }
                                            />
                                            { item?.isExtraRequest &&
                                                <CustomChip
                                                    background={colors.secondary100}
                                                    borderColor={colors.secondary150}
                                                    fontColor={colors.secondary700}
                                                    legend={t("requested_by_manager")}
                                                />
                                            }
                                            <CustomTooltip
                                                text={
                                                    item?.isExtraRequest ? <>
                                                        <p className={"ibl-font-w-600 fs-12px"}>{getFullName(item.requestedByName,item.requestedByLastName,item.requestedBySecondLastName)}</p>
                                                        <p className={"fs-12px"}>{item?.description}.</p>
                                                    </> : null
                                                }
                                                placement="left"
                                            >
                                                 <span className="d-inline-block">
                                                     <ButtonIcon
                                                         id="btn_or_requester"
                                                         Icon={IconTextMessage}
                                                         iconProps='btn-icon-svg-24px btn-icon-svg-white'
                                                         className={`btn-icon-secondary-600 border-radius-50`}
                                                         disabled={!item?.isExtraRequest}
                                                     />
                                                 </span>
                                            </CustomTooltip>
                                        </div>
                                    }
                                >
                                    {/*CONTENT*/}
                                    <div className='d-flex flex-column align-items-start gap-3 stretch-self w-100'>
                                        <div className='d-flex flex-column justify-content-center align-items-center stretch-self gap-2 w-100'>
                                            <div className='ibl-h3 ibl-font-w-600 font-color-general-950 text-center text-break-wrap'>
                                                { getFullName(item.userName,item.userLastName,item.userSecondLastName) }
                                            </div>
                                            <CustomChip
                                                background={colors.secondary100}
                                                borderColor={colors.secondary150}
                                                fontColor={colors.secondary700}
                                                legend={ t("employee_id") + ": " + (item?.employeeIdentifier || EMPTY_VALUES.DEFAULT)}
                                            />
                                            <CustomChip
                                                background={colors.secondary100}
                                                borderColor={colors.secondary150}
                                                fontColor={colors.secondary700}
                                                legend={MEAL_CATEGORY[item?.isExtraRequest] ? t(MEAL_CATEGORY[item?.isExtraRequest]) : EMPTY_VALUES.DEFAULT}
                                            />
                                        </div>

                                        <div className='border-bottom-shades-300-2px'/>
                                        <Resume title={t("starter")} value={item?.starter?.name || EMPTY_VALUES.DEFAULT} />
                                        <div className='border-bottom-shades-300'/>
                                        <Resume title={t("main_course")} value={item?.main?.name || EMPTY_VALUES.DEFAULT} />
                                        <div className='border-bottom-shades-300'/>
                                        <Resume title={t("side_dish")} value={item?.side?.name || EMPTY_VALUES.DEFAULT} />
                                        <div className='border-bottom-shades-300'/>
                                        <Resume title={t("dessert")} value={item?.dessert?.name || EMPTY_VALUES.DEFAULT} />
                                        <div className='border-bottom-shades-300-2px'/>

                                        <div className='ibl-ientry-p ibl-font-w-600 font-color-shades-600 text-center text-break-wrap'>
                                            {getTimeFormat(item.requestDate)}
                                        </div>
                                    </div>
                                    {/*FOOTER*/}
                                    <div className='d-flex justify-content-end align-items-start gap-2 stretch-self w-100'>
                                        { ( DEV || permission?.includes(permissionObj?.WEB_KITCHEN_TICKETS_READ) ) &&
                                            <ButtonAction
                                                id='btn_or_mark_as_completed'
                                                name='mark_as_completed'
                                                className={`btn-secondary-600 no-hover w-100`}
                                                splitName={false}
                                                onClick={() => {
                                                    handleMarkAsCompleted(item);
                                                }}
                                            />
                                        }
                                    </div>
                                </CustomCardGridGeneral>
                            </div>
                            ))
                        }
                    </div>
                </div>
            ) :
                <NotInformation card={true} text={t("no_orders_to_display_right_now")}/>
            }
        </>
    </>)

}

export default Order;
